var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top_bar"},[_c('el-menu',{attrs:{"active-text-color":_vm.variables.menuActiveText,"default-active":_vm.activeMenu,"mode":"horizontal"},on:{"select":_vm.handleSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }